import { useState } from "react";

const WorksheetSearchBar = ({
  handleFilter,
  placeholder = "학습지명 검색",
}) => {
  const [keyword, setKeyword] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter(keyword);
    }
  };

  return (
    <div
      style={{
        position: "relative", // 입력 필드와 버튼을 포지셔닝하기 위한 컨테이너
      }}
    >
      <input
        type="text"
        placeholder={placeholder}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={handleKeyDown}
        style={{
          width: "100%",
          padding: "10px", // 버튼이 들어갈 공간 확보
          paddingLeft: "15px",
          border: "1px solid #2D2D2D",
          borderRadius: "4px",
          boxSizing: "border-box",
          fontSize: "16px",
        }}
      />
      <button
        onClick={() => handleFilter(keyword)}
        style={{
          position: "absolute", // 버튼을 입력 필드 안쪽으로 배치
          top: "50%",
          right: "0px", // 입력 필드 오른쪽 여백
          transform: "translateY(-50%)", // 수직 가운데 정렬
          padding: "5px 10px",
          cursor: "pointer",
          backgroundColor: "transparent",
          border: "none",
          fontSize: "16px",
        }}
      >
        {/* SVG 아이콘 삽입 */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#2D2D2D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ width: "20px", height: "20px" }}
        >
          <circle cx="11" cy="11" r="7"></circle>
          <line x1="40" y1="40" x2="16.65" y2="16.65"></line>
        </svg>
      </button>
    </div>
  );
};

export default WorksheetSearchBar;
